const fn = function(id) {
    return fn.cid + "-" + id
};

fn.cid = 'cid'

export default fn
